import { createSelector } from 'reselect';
import { isTimeEnded } from 'core/utils/helpers/date';
import { selectActiveCurrentDate } from 'core/selectors/env';
import get from 'lodash/get';

export const selectBonusTiers = state => state.bonusTiers;
export const selectBonusTiersConfig = createSelector(
  selectBonusTiers,
  bonusTiers => bonusTiers.config,
);

export const selectBonusTiersIsLoading = createSelector(
  selectBonusTiers,
  bonusTiers => bonusTiers.isLoading,
);

export const selectBonusTiersIsLoaded = createSelector(
  selectBonusTiers,
  bonusTiers => bonusTiers.isLoaded,
);

export const selectMerchantIndependentActiveBonus = createSelector(
  [selectBonusTiers, selectActiveCurrentDate],
  (bonusTiers, currentDate) => {
    const { bonus = [] } = bonusTiers;
    const firstMerchantIndependentBonus = bonus.filter(el => !get(el, 'offers[0].qualifyingMerchants.merchants[0]'))[0];

    return (!firstMerchantIndependentBonus || isTimeEnded(firstMerchantIndependentBonus.endDate, currentDate)) ?
      [] :
      firstMerchantIndependentBonus;
  },
);

export const selectBonusTiersPlacement = createSelector(
  selectMerchantIndependentActiveBonus,
  bonus => get(bonus, 'offers[0].qualifyingSpendTiers', []),
);

export const selectBonusTiersCount = createSelector(
  selectMerchantIndependentActiveBonus,
  bonus => get(bonus, 'offers[0].qualifyingSpendTiers', []).length,
);

export const selectBonusTerms = createSelector(
  selectMerchantIndependentActiveBonus,
  bonus => get(bonus, 'offers[0].terms', ''),
);
